import React from 'react';

interface TimerDisplayProps {
  values: number[]; // e.g. [1, 9, 23]
  labels: string[]; // e.g. ['days', 'hours', 'minutes']
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({ values, labels }) => {
  // Helper to split a value into two digits (pads with 0)
  const getDigits = (val: number) => {
    const str = val.toString().padStart(2, '0');
    return [str[0], str[1]];
  };

  return (
    <div style={{ width: 224, maxWidth: '100%', paddingTop: 10, paddingRight: 20, marginRight: 20,marginLeft:-8 }}>
      {/* Top row: digit boxes and colons */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: 8 }}>
        {values.map((val, idx) => (
          <React.Fragment key={idx}>
            {/* Pair of digit boxes and label as a column */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 62, marginTop: 6 }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                {getDigits(val).map((digit, dIdx) => (
                  <div key={dIdx} style={{
                    width: 30,
                    height: 39,
                    borderRadius: 6,
                    background: '#EFEFEF',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    marginRight: dIdx === 0 ? 2 : 0, // small space between the two boxes
                  }}>
                    <span style={{
                      fontFamily: 'SF Pro Text',
                      fontWeight: 700,
                      fontSize: 14,
                      lineHeight: '28px',
                      letterSpacing: 0.875,
                      color: '#000',
                      width: 10,
                      height: 28,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 6,
                    }}>{digit}</span>
                  </div>
                ))}
              </div>
              {/* Label below the pair */}
              <span style={{
                fontFamily: 'SF Pro Text',
                fontWeight: 500,
                fontSize: 14,
                lineHeight: '28px',
                letterSpacing: 0.875,
                color: '#000',
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 0,
              }}>{labels[idx]}</span>
            </div>
            {/* Colon between units */}
            {idx < values.length - 1 && (
              <span style={{
                fontFamily: 'SF Pro Text',
                fontWeight: 700,
                fontSize: 20,
                lineHeight: '28px',
                letterSpacing: 0.875,
                color: '#000',
                margin: '0 4px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>:</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TimerDisplay; 